import React from "react";
import {
    Button,
    Select,
    FormControl as Input,
    Table,
    Modal,
    Message,
    Popconfirm,
} from "tinper-bee";
import Layout from "../../pages/Layout";
import { get, post, put, del } from "../../utils";

const { Option } = Select;

interface IuapVersion {
    id?: number;
    envCode: string;
    envName: string;
    version: string;
    create_time?: string;
    update_time?: string;
}

interface IuapVersionControlState {
    dataSource: IuapVersion[];
    loading: boolean;
    visible: boolean;
    editingRecord: IuapVersion | null;
    environmentOptions: any[];
    envCode: string;
    version: string;
}

class IuapVersionControl extends React.Component<any, IuapVersionControlState> {
    constructor(props: any) {
        super(props);
        this.state = {
            dataSource: [],
            loading: false,
            envCode: "",
            version: "",
            visible: false,
            editingRecord: null,
            environmentOptions: [
                {
                    envCode: "premisev5r0",
                    envName: "私有化环境-V5R0",
                },
                {
                    envCode: "daily-dedicated",
                    envName: "日常多数据库环境",
                },
                {
                    envCode: "pre",
                    envName: "预发环境",
                },
                {
                    envCode: "daily",
                    envName: "日常环境",
                },
                {
                    envCode: "test",
                    envName: "测试环境",
                },
            ],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState({ loading: true });
        try {
            const response = await get("/tns3rd/iuap-3rd-party/version");
            if (response.success) {
                this.setState({ dataSource: response.data });
            } else {
                Message.create({
                    content: response.message || "获取数据失败",
                    color: "danger",
                });
            }
        } catch (error) {
            Message.create({ content: "获取数据失败", color: "danger" });
            console.error("Error fetching data:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleAdd = () => {
        this.setState({
            visible: true,
            editingRecord: null,
        });
    };

    handleEdit = (record: IuapVersion) => {
        this.setState({
            visible: true,
            editingRecord: record,
            envCode: record.envCode,
            version: record.version,
        });
    };

    handleDelete = async (id: number) => {
        try {
            const response = await del(`/tns3rd/iuap-3rd-party/version/${id}`);
            if (response.success) {
                Message.create({ content: "删除成功!", color: "success" });
                this.fetchData();
            } else {
                Message.create({
                    content: response.message || "删除失败",
                    color: "danger",
                });
            }
        } catch (error) {
            Message.create({ content: "删除失败", color: "danger" });
        }
    };

    handleOk = async () => {
        let { envCode, version, editingRecord, environmentOptions } =
            this.state;
        if (!envCode || !version) {
            return Message.create({
                content: "请填写环境名称和版本号",
                color: "danger",
            });
        }
        let envName = environmentOptions.find(
            (item) => item.envCode === envCode
        ).envName;
        version = version.trim();
        const values = {
            envCode,
            version,
            envName,
        };
        if (!this.validateVersion(version)) {
            return Message.create({
                content: "请输入正确的版本号",
                color: "danger",
            });
        }
        try {
            let response;
            if (editingRecord) {
                // 更新
                response = await put(
                    `/tns3rd/iuap-3rd-party/version/${editingRecord.id}`,
                    values
                );
            } else {
                // 新增
                response = await post("/tns3rd/iuap-3rd-party/version", values);
            }

            if (response.success) {
                Message.create({
                    content: editingRecord ? "更新成功" : "新增成功",
                    color: "success",
                });
                this.setState({ visible: false });
                this.fetchData();
            } else {
                Message.create({
                    content: response.message || "操作失败",
                    color: "danger",
                });
            }
        } catch (error) {
            Message.create({ content: "删除失败", color: "danger" });
            console.error("Error saving data:", error);
        }
    };

    handleCancel = () => {
        this.setState({ visible: false, version: "", envCode: "" });
    };

    validateVersion = (version: string): boolean => {
        const versionRegex = /^15\.\d+\.\d+$/;
        return versionRegex.test(version);
    };

    columns = [
        {
            title: "环境",
            dataIndex: "envCode",
            key: "envCode",
            width: 300,
            render: (text, rec) => {
                return `${rec.envName} (${text}) `;
            },
        },
        {
            title: "固化版本号",
            dataIndex: "version",
            key: "version",
            width: 200,
        },
        {
            title: "创建时间",
            dataIndex: "create_time",
            key: "create_time",
            width: 180,
            render: (text: string) => {
                if (!text) return "-";
                return new Date(text).toLocaleString();
            },
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            key: "update_time",
            width: 180,
            render: (text: string) => {
                if (!text) return "-";
                return new Date(text).toLocaleString();
            },
        },
        {
            title: "操作",
            key: "action",
            width: 150,
            render: (text: any, record: IuapVersion) => (
                <div>
                    <Button
                        size="sm"
                        colors="primary"
                        onClick={() => this.handleEdit(record)}
                        style={{ marginRight: 8 }}
                    >
                        编辑
                    </Button>
                    <Popconfirm
                        title="确定要删除这条记录吗？"
                        onClose={() => this.handleDelete(record.id!)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button size="sm" colors="danger">
                            删除
                        </Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    render() {
        const {
            dataSource,
            loading,
            visible,
            editingRecord,
            environmentOptions,
            envCode,
            version,
        } = this.state;

        return (
            <div className="iuap-version-control" style={{ padding: 12, height: "100vh" }}>
                <div className="page-header">
                    <h1 style={{textAlign:"center"}}>iuap-3rd-party各环境构建态固化版本控制</h1>
                    <Button
                        colors="primary"
                        onClick={this.handleAdd}
                        style={{ marginBottom: 16 }}
                    >
                        <span className="icon-plus">+</span> 新增版本
                    </Button>
                </div>

                <Table
                    columns={this.columns}
                    data={dataSource}
                    loading={loading}
                    pagination={false}
                    bordered
                />

                <Modal show={visible}>
                    <Modal.Header>
                        <Modal.Title>
                            {editingRecord ? "编辑版本" : "新增版本"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div>
                                <label>环境:</label>
                                <Select
                                    onSelect={(value) =>
                                        this.setState({ envCode: value })
                                    }
                                    name="envCode"
                                    value={envCode}
                                    style={{ width: "100%" }}
                                >
                                    {environmentOptions.map((env) => (
                                        <Option
                                            key={env.envCode}
                                            value={env.envCode}
                                        >
                                            {env.envName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div>
                                <label>版本:</label>
                                <Input
                                    name="version"
                                    onChange={(e) =>
                                        this.setState({
                                            version: e.target
                                                ? e.target.value
                                                : e,
                                        })
                                    }
                                    value={version}
                                    style={{ width: "95%" }}
                                    placeholder="例如: 15.0.0"
                                />
                                <div
                                    style={{
                                        color: "#999",
                                        fontSize: "12px",
                                        marginTop: "4px",
                                    }}
                                >
                                    格式要求：必须以15开头的语义化版本号，如：15.0.0、15.1.2等
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            style={{ marginRight: 20 }}
                            onClick={this.handleCancel}
                        >
                            取消
                        </Button>
                        <Button colors="primary" onClick={this.handleOk}>
                            确定
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default Layout(IuapVersionControl, 'tne3rd-page')
